import { isHotkeyPressed } from "react-hotkeys-hook"

import { PLATFORM_HAS_COMMAND_KEY } from "@constants/platforms"

function isModKeyPressed(event?: React.MouseEvent<HTMLElement, MouseEvent>) {
    if (!event) {
        return PLATFORM_HAS_COMMAND_KEY ? isHotkeyPressed("command+click") : isHotkeyPressed("ctrl+click")
    } else {
        return PLATFORM_HAS_COMMAND_KEY ? event.metaKey : event.ctrlKey
    }
}

export default isModKeyPressed
